



































































































































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs, ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { CdpDetailItem } from "@/store/cdp/statistic/types";
import {dateFilter} from "@/utils/date-util";
import { colorClassByStatus } from "@/utils/page-utils";
import CdpDetailFilter from "@/components/CDP/Statistic/CdpDetailFilter.vue";

@Component({
  components: {CdpDetailFilter, Tabs, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class CdpDetail extends BaseItemsPage<CdpDetailItem> {

  @Getter("cdpStaticDetail") responseItems!: CdpDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  activeFilter: string  = '';
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      'id',
      'create_date',
      'partner',
      'broker_account_login',
      'message_type',
      'status',
      'ext_event_profile_id',
      'ext_client_profile_id',
      'error_code',
      'detail'
    ];
  }

  getData() {
    return this.responseItems;
  }

  changeFilter(filter: string) {
    if (this.activeFilter === filter){
      this.activeFilter = '';
    } else{
      this.activeFilter = filter;
    }
  }
}
